import { IonIcon } from '@ionic/react'
import { leaf } from 'ionicons/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { co2PerKwh } from '../../../../constants'
import useUser from '../../../../contexts/hooks/useUser'
import { getMonthString } from '../../../../modules/consumptionDataParser'

interface Props {
	consideredMonth: any
}

const NatureCircle: React.FC<Props> = ({ consideredMonth }) => {
	const { user } = useUser()

	const { t } = useTranslation('pages_overview')

	const co2Amount = consideredMonth.kwh * co2PerKwh

	return (
		<div className='slide-container'>
			<div id='circle' className='bg-white dark:bg-background-200-dark'>
				<div
					id='inner'
					className='bg-white dark:bg-background-200-dark text-text-dark dark:text-text-light'
				>
					<IonIcon
						icon={leaf}
						className='text-brand-primary-100-light mb-1 dark:text-brand-primary-100-dark'
					/>
					<span className='current-month-title'>
						{getMonthString(consideredMonth.localTime.month, user?.language)}
					</span>
					<span className='main-value'>
						{Math.floor(co2Amount).toFixed(0)}
						<span className='cents'>,{co2Amount.toFixed(2).split('.')[1]}</span>
						<span className='unit text-text-grey-300 dark:text-text-grey-100'>
							Co<sup>2</sup>kg
						</span>
					</span>
					<div className='bottom'>
						<span>{t('circles.saastetty')}*</span>
					</div>
				</div>
			</div>
		</div>
	)
}
export default NatureCircle
